module.exports = __webpack_public_path__ + "img/lift1.48176da7.png";